// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

// NOTE - IE grid needs to use a second column as 'auto'
// to place the loading/clear/unit-label.

export const UpdatedLabeledInputWrapper = styled.div`
  display: grid;
  grid-column-gap: .15em;
  grid-row-gap: .15em;
  grid-template-areas:
    "label label"
    "input lookup"
    "error error";
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 2em 1fr;

  > .label {
    grid-area: label;
    display: block;
  }

  > .input {
    grid-area: input;

    border: 1px solid;
    border-radius: .15em;
    font-size: 1em;
    height: 2em;
    overflow: hidden;
    padding: .25em;
    text-overflow: ellipsis;

    &:disabled {
      opacity: .8;
    }
  }

  > .clear-input,
  > .loading,
  > .unit-label {
    grid-area: input;
    align-self: end;
    display: block;
    line-height: 2em;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: .25em;
    margin-top: auto;
    transition: opacity .2s ease-out;
  }

  > .clear-input {
    opacity: 0;
  }

  &:hover {
    > .clear-input {
      opacity: 1;

      & + .loading,
      & + .unit-label {
        opacity: 0;
      }
    }
  }

  > .loading {
    & + .unit-label {
      opacity: 0;
    }
  }

  > .lookup {
    grid-area: lookup;

    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 2em;
  }


  > .error-message {
    grid-area: error;
  }

  > .label,
  > .unit-label {
    // .heading-font
    font-family: refrigerator-deluxe, sans-serif;
  }
`
